export const stateTypes = Object.freeze({
    POSITION: 'position',
    NAME: 'name',
    TEE: 'tee',
    TO_PAR: 'to-par',
    HOLE: 'hole',
    TODAY: 'today'
});
